<template>
    <content-builder-form-editor
        class="hidden"
        ref="editor"
        :key="schemaKey"
        :schema-key="schemaKey"
        @ready="editorReady">
    </content-builder-form-editor>
</template>

<script>
import ContentBuilderFormEditor from './ContentBuilderFormEditor.vue'
import EventBus from '../helpers/event-bus'

export default {
    components: {
        ContentBuilderFormEditor
    },
    data () {
        return {
            promise: null,
            tmpSchemaRef: false
        }
    },
    computed: {
        schemaRefs () {
            return this.$store.getters['builder/schemaRefs']
        },
        schemaKey () {
            if (this.schemaRefs?.definitions[this.tmpSchemaRef]) {
                return this.tmpSchemaRef
            }
            return `screens/${this.tmpSchemaRef}/schema.json`
        }
    },
    methods: {
        generateDefaultData (schemaRef, resolve, reject) {
            console.log(`Generating default data for ${schemaRef}`)
            this.promise = { resolve, reject }
            this.tmpSchemaRef = schemaRef
        },
        editorReady () {
            if (this.promise) {
                try {
                    const value = this.$refs['editor'].getValue()
                    this.promise.resolve(value)
                    this.tmpSchemaRef = false
                } catch (err) {
                    this.promise.reject(err)
                }
                this.promise = null
            }
        }
    },
    mounted () {
        EventBus.$on('data:generate', this.generateDefaultData)
    }
}
</script>